import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumbersSeparatorDirective } from 'src/app/core/directives/numbers-separator.directive';
import { OnlyNumberDirective } from 'src/app/core/directives/only-number.directive';
import { NumberSeparatorPipe } from 'src/app/core/pipes/number.separator.pipe';

@Component({
    selector: 'phonebook-row-input',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        OnlyNumberDirective,
        NumbersSeparatorDirective,
        NumberSeparatorPipe,
    ],
    template: `
    <input
      [onlyNumbers]="true"
      type="tel"
      min="1"
      [max]="max"
      placeholder="0"
      numberSeparator
      (ngModelChange)="value = $event"
      [ngModel]="value | numberSeparator"
      class="tw-border dark:tw-border-dark-100 tw-text-center dark:tw-bg-dark-400 tw-w-[56px] tw-mx-1 dir-ltr disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
      (input)="onChange()"
      [disabled]="disabled"
      [ngClass]="{
        'tw-bg-[#ffe2e2] dark:!tw-bg-transparent !tw-border-[1.5px] !tw-border-rose-500 ':
          !isValid && !disabled && checked
      }"
    />
  `,
    styles: [
        `
      .index-input {
        height: 22px;
        border-radius: 3px;
        font-weight: 500;
        font-size: 12px;

        &:focus-visible {
          border: 1.2px solid #5d5d5d;
          outline: 0px !important;
          border-radius: 2px;
        }

        &::placeholder {
          text-align: center;
        }

        &::-webkit-inner-spin-button,
        ::-webkit-outer-spin-button {
          opacity: 1;
        }
      }
    `,
    ]
})
export class PhonebookRowInputComponent {
  @Input() max: number;
  @Input() disabled: boolean;
  @Input() value: any;
  @Input() isValid: boolean = true;
  @Input() checked: boolean = true;
  @Output() valueChange = new EventEmitter<any>();

  ngOnInit(): void {
    this.onChange();
  }

  onChange() {
    this.value = this.value?.replace(/,/g, '');
    if (!isNaN(+this.value)) this.valueChange.emit(+this.value);
  }
  
}
